// blog data

export const Blogs = [
    {
        id:1,
        name:"THE SALOON",
        tags:["Adobe XD","Photoshop"],
        date:"Mar 7, 2023",
        imgSrc:"https://cdn.dribbble.com/userupload/5172078/file/original-d4852dd4f51845b0aef131f63b14f521.png",
         link:"https://dribbble.com/shots/20846824-THE-SALOON-Florida"
    },
    {
        id:2,
        name:"Guri's Shoes",
        tags:["Figma","Photoshop"],
        date:"Mar 10, 2021",
        imgSrc:"https://cdn.dribbble.com/userupload/5247117/file/original-162b5b5a1e7b8eb92b97925da702e35c.png?compress=1&resize=1200x600",
         link:"https://dribbble.com/shots/20875608-Guri-s-Shoes"
    },
    {
        id:3,
        name:"Uniswap",
        tags:["Figma","Photoshop"],
        date:"Mar 11, 2023",
        imgSrc:"https://cdn.dribbble.com/userupload/5272501/file/original-df08fa5165c9bc9991419048541d45fa.png?compress=1&resize=1024x757",
         link:"https://dribbble.com/shots/20884943-Uniswap"
    },
    {
        id:4,
        name:"GSRM Wallet",
        tags:["Figma","Photoshop"],
        date:"Mar 12, 2023",
        imgSrc:"https://cdn.dribbble.com/userupload/5287270/file/original-7a49100b319ff9edfb546e4693b0217e.png",
         link:"https://dribbble.com/shots/20890246-GSRM-Wallet"
    },
    {
        id:5,
        name:"SNACKO-The Hungry Hub",
        tags:["Figma","Photoshop"],
        date:"Mar 13, 2023",
        imgSrc:"https://cdn.dribbble.com/userupload/5313211/file/original-b3b6c3e2dfed00cc5312a21a9040595a.png?compress=1&resize=1024x512",
         link:"https://dribbble.com/shots/20900377-SNACKO-The-Hungry-Hub"
    },
    {
        id:6,
        name:"Adopets",
        tags:["Figma","Photoshop"],
        date:"Mar 16, 2023",
        imgSrc:"https://cdn.dribbble.com/userupload/5403463/file/original-446e7a6ca0d02305a3e81e348b3b5e7c.png?compress=1&resize=1024x709",
         link:"https://dribbble.com/shots/20935066-Adopets"

    },
   
    {
        id:7,
        name:"Metro",
        tags:["Figma","Photoshop"],
        date:"Mar 16, 2023",
        imgSrc:"https://cdn.dribbble.com/userupload/5403780/file/original-2323079fb217752a2a3f0bd4eabb477b.png?compress=1&resize=1200x853",
         link:"https://dribbble.com/shots/20935165-Metro"
    },  
] 